import numeral from 'numeral';

numeral.register('locale', 'it_IT', {
  delimiters: {
    thousands: ',',
    decimal: '.',
  },
  abbreviations: {
    thousand: 'K',
    million: 'MM',
    billion: 'BN',
    trillion: 'TN',
  },
  currency: {
    symbol: '$',
  },
});

numeral.locale('it_IT');
